import {$, $$, empty, getParentElementById, getParentElementByTagName, hide, toggle} from "./Dom.ts";
import {createDataTables, registerFiltreApi} from "./DataTables.ts";
import {$get, $post} from "./Ajax.ts";
import {getAttributeOrUndefined, removeUndefined} from "./Utils.ts";
import {initAjaxModale} from "./Modal.ts";
import {initTooltips} from "./Tooltip.ts";
import type {Api} from "datatables.net";
import {animateLoadingButton} from "./Animate.ts";
import {initLinkToOnglet} from "./Onglets.ts";

const datatables: Api[] = []

export function viderOngletGeographie() {
    const container = $("#geographie-onglet-content")
    empty(container)
    for (const datatable of datatables) {
        datatable.destroy()
    }
    datatables.length = 0
}

export function initGeographieOnglet() {
    const container = $("#geographie")
    if (!container) return
    $$('.fr-accordion__btn[aria-controls]', container).forEach(onglet => {
        if (onglet.getAttribute("aria-controls") === "parcours-synthese") {
            loadAccordion({target: onglet})
        }
        onglet.addEventListener("click", loadAccordion)
    })
    initLinkToOnglet(container)
}

function loadAccordion(event: DOMEvent<HTMLElement>) {
    const button = getParentElementByTagName(event.target, "button")
    if (!button) return
    if (button.hasAttribute("data-loaded")) return

    const child = $(`#${button.getAttribute("aria-controls")}`)
    if (!child) return

    const params = removeUndefined({
        dossier: child.getAttribute("data-dossier"),
        onglet: child.getAttribute("data-onglet"),
    })
    $get(window.Openscop.url_get_geographie_onglet_content, params).then((response) => {
        child.innerHTML = response.body
        initListeners(child)
        initTooltips(child)
        initCommuneListe(child)
        button.setAttribute("data-loaded", "true")
        initLinkToOnglet(child)
    })
}

function initListeners(container: HTMLElement) {
    $('#btn-show-arrondissements-synthese', container)?.addEventListener('click', showSyntheseModal)
    $('#btn-show-communes-synthese', container)?.addEventListener('click', showSyntheseModal)
    $('#lancer_analyse_parcours', container)?.addEventListener('click', start_analyse_parcours)
}

function start_analyse_parcours(event: DOMEvent<HTMLElement>) {
    const target = getParentElementById(event.target, "lancer_analyse_parcours")
    if (!target) return

    const url = target.getAttribute('data-url')
    const id = target.getAttribute("data-id")
    if (url && id) {
        target.setAttribute('disabled', "true")
        const headers = new Headers()
        headers.append('Content-Type', 'application/json')
        const animation = animateLoadingButton(target, "L'analyse a été lancé, cela peut prendre un certain temps.")
        $post(url, {id}, headers).catch(() => {
            animation?.resetBtn()
        })
    }
}

function initCommuneListe(parent: HTMLElement) {
    const table = $('.table-communes', parent)
    if (!table) return

    const ordonnees = getAttributeOrUndefined(table, "data-ordonnee")
    const temp_col = []
    if (ordonnees === "True") {
        temp_col.push({"targets": [0], width: 75, 'searchtype': "text", className: "dt-head-center dt-body-center"})
        temp_col.push({"targets": [1], 'searchtype': "text", className: "dt-head-center dt-body-center"})
        temp_col.push({"targets": [2], 'searchtype': "select", className: "dt-head-center dt-body-center"})
        temp_col.push({"targets": [3], 'searchtype': "select", className: "dt-head-center dt-body-center"})
        temp_col.push({"targets": [4], width: 75, className: "dt-head-center dt-body-center"})
    } else {
        temp_col.push({"targets": [0], 'searchtype': "text", className: "dt-head-center dt-body-center"})
        temp_col.push({"targets": [1], 'searchtype': "select", className: "dt-head-center dt-body-center"})
        temp_col.push({"targets": [2], 'searchtype': "select", className: "dt-head-center dt-body-center"})
        temp_col.push({"targets": [3], width: 75, className: "dt-head-center dt-body-center"})
    }

    let order_by = 0
    const columns_export_option = ''

    // on peut ajouter 'width': 200 si besoin
    function formatExportcolumn(_data: any, _row: number, _column: number, node: HTMLElement) {
        let returnData = node.textContent?.trim()
        const child = $('span[hidden]', node)
        if (child) returnData = child.innerText
        return returnData
    }

    createDataTables(table, {
        paging: false, info: false, columnDefs: temp_col, dom: 'Bfrtip', buttons: {
            buttons: [{
                extend: 'csv',
                text: "Télécharger en csv",
                className: 'fr-btn fr-mb-1w supprimer_class',
                exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }, {
                extend: 'excelHtml5',
                text: "Télécharger en excel",
                className: 'fr-btn fr-mb-1w supprimer_class',
                exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }, {
                extend: 'pdfHtml5',
                text: "Télécharger en pdf",
                className: 'fr-btn fr-mb-1w supprimer_class',
                orientation: 'landscape',
                pageSize: 'A3',
                exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }, {
                extend: 'print', text: "Imprimer", className: 'fr-btn fr-mb-1w  supprimer_class', exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }],
        }, colReorder: true, fixedHeader: true, // stateSave: true,
        order: [[order_by, "asc"]], initComplete: function () {
            const resetFiltres = registerFiltreApi(this.api())
            $('.btn-filter', parent)?.addEventListener('click', () => {
                const filter = $('thead.filter', parent)
                const exportbtns = $('.dt-buttons', parent)
                toggle(filter)
                toggle(exportbtns)
                if (filter?.classList.contains('d-none')) {
                    resetFiltres()
                }
            });
        }
    }).then((infos) => {
        hide($('.dt-search', parent))
        hide($('.dataTables_filter', parent))
        hide($('thead.filter', parent));
        const exportbtns = $('.dt-buttons', parent)
        hide(exportbtns)

        initShowRues(parent)
        datatables.push(infos.datatable)
    })
}

function initShowRues(parent: HTMLElement) {
    $$(".show-rues", parent).forEach(btn => {
        btn.addEventListener('click', showRues)
    })
}

function showRues(event: DOMEvent<HTMLElement>) {
    const target = getParentElementByTagName(event.target, "button")
    if (!target) return
    const parcours = getAttributeOrUndefined(target, "data-parcours")
    const parcoursName = getAttributeOrUndefined(target, "data-parcours-name")
    const commune = getAttributeOrUndefined(target, "data-commune")

    if (!parcours) return

    initAjaxModale("modal-rues", {
        title: parcoursName ? `Voire toute les rues pour ${parcoursName}` : "Voire toute les rues", title_in_header: true,
    }, window.Openscop.url_get_geographie_routes_traversees, removeUndefined({parcours, commune})).then((modale) => {
        initRueListe(modale)
    })
}

function initRueListe(parent: HTMLElement) {
    const table = $("#rue-liste", parent)
    if (!table) return

    const temp_col = []

    temp_col.push({"targets": [0], width: 75, 'searchtype': "number", className: "dt-head-center dt-body-center"})
    temp_col.push({"targets": [1], 'searchtype': "text", className: "dt-head-center dt-body-center"})
    temp_col.push({"targets": [2], 'searchtype': "select", className: "dt-head-center dt-body-center"})

    let order_by = 0
    const columns_export_option = ''

    // on peut ajouter 'width': 200 si besoin
    function formatExportcolumn(_data: any, _row: number, _column: number, node: HTMLElement) {
        let returnData = node.textContent?.trim()
        const child = $('span[hidden]', node)
        if (child) returnData = child.innerText
        return returnData
    }

    createDataTables(table, {
        language: {
            "search": "Rechercher",
            emptyTable: 'Les rues ne sont pas encore analysées, revenez plus tard.'
        },
        paging: false,
        info: false,
        columnDefs: temp_col,
        dom: 'Bfrtip',
        buttons: {
            buttons: [{
                extend: 'csv',
                text: "Télécharger en csv",
                className: 'fr-btn fr-mb-1w supprimer_class',
                exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }, {
                extend: 'excelHtml5',
                text: "Télécharger en excel",
                className: 'fr-btn fr-mb-1w supprimer_class',
                exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }, {
                extend: 'pdfHtml5',
                text: "Télécharger en pdf",
                className: 'fr-btn fr-mb-1w supprimer_class',
                orientation: 'landscape',
                pageSize: 'A3',
                exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }, {
                extend: 'print', text: "Imprimer", className: 'fr-btn fr-mb-1w  supprimer_class', exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }],
        },
        colReorder: true,
        fixedHeader: false, // stateSave: true,
        order: [[order_by, "asc"]], initComplete: function () {
            const resetFiltres = registerFiltreApi(this.api())
            $('.btn-filter', parent)?.addEventListener('click', () => {
                const filter = $('thead.filter', parent)
                const exportbtns = $('.dt-buttons', parent)

                toggle(exportbtns)
                toggle(filter)
                if (filter?.classList.contains('d-none')) {
                    resetFiltres()
                }
            });
        }
    }).then((infos) => {
        hide($('.dt-search', parent))
        hide($('.dataTables_filter', parent))
        hide($('thead.filter', parent));
        const exportbtns = $('.dt-buttons', parent)
        hide(exportbtns)
        datatables.push(infos.datatable)
    })
}

function showSyntheseModal(event: DOMEvent<HTMLElement>) {
    const target = getParentElementByTagName(event.target, "button")
    if (!target) return
    const url = getAttributeOrUndefined(target, "data-url")
    const type = getAttributeOrUndefined(target, "data-type")!

    if (!url) return
    let callback: Function = initArrondissementsSyntheseList
    switch (type) {
        case "communes":
            callback = initCommunesSyntheseList
            break
    }

    initAjaxModale("modal-communes", {}, url).then((modale) => {
        callback(modale)
    })
}

function initCommunesSyntheseList(parent: HTMLElement) {
    const table = $("#communes-liste", parent)
    if (!table) return

    const temp_col = []

    temp_col.push({"targets": [0], 'searchtype': "text", className: "dt-head-center dt-body-center"})
    temp_col.push({"targets": [1], 'searchtype': "select", className: "dt-head-center dt-body-center"})
    temp_col.push({"targets": [2], 'searchtype': "select", className: "dt-head-center dt-body-center"})

    let order_by = 0
    const columns_export_option = ''

    // on peut ajouter 'width': 200 si besoin
    function formatExportcolumn(_data: any, _row: number, _column: number, node: HTMLElement) {
        let returnData = node.textContent?.trim()
        const child = $('span[hidden]', node)
        if (child) returnData = child.innerText
        return returnData
    }

    createDataTables(table, {
        paging: false,
        info: false,
        columnDefs: temp_col,
        dom: 'Bfrtip',
        buttons: {
            buttons: [{
                extend: 'csv',
                text: "Télécharger en csv",
                className: 'fr-btn fr-mb-1w supprimer_class',
                exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }, {
                extend: 'excelHtml5',
                text: "Télécharger en excel",
                className: 'fr-btn fr-mb-1w supprimer_class',
                exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }, {
                extend: 'pdfHtml5',
                text: "Télécharger en pdf",
                className: 'fr-btn fr-mb-1w supprimer_class',
                orientation: 'landscape',
                pageSize: 'A3',
                exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }, {
                extend: 'print', text: "Imprimer", className: 'fr-btn fr-mb-1w  supprimer_class', exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }],
        },
        colReorder: true,
        fixedHeader: false, // stateSave: true,
        order: [[order_by, "asc"]], initComplete: function () {
            const resetFiltres = registerFiltreApi(this.api())
            $('.btn-filter', parent)?.addEventListener('click', () => {
                const filter = $('thead.filter', parent)
                const exportbtns = $('.dt-buttons', parent)

                toggle(exportbtns)
                toggle(filter)
                if (filter?.classList.contains('d-none')) {
                    resetFiltres()
                }
            });
        }
    }).then((infos) => {
        hide($('.dt-search', parent))
        hide($('.dataTables_filter', parent))
        hide($('thead.filter', parent));
        const exportbtns = $('.dt-buttons', parent)
        hide(exportbtns)
        datatables.push(infos.datatable)
    })
}

function initArrondissementsSyntheseList(parent: HTMLElement) {
    const table = $("#arrondissements-liste", parent)
    if (!table) return

    const temp_col = []

    temp_col.push({"targets": [0], 'searchtype': "text", className: "dt-head-center dt-body-center"})
    temp_col.push({"targets": [1], 'searchtype': "select", className: "dt-head-center dt-body-center"})

    let order_by = 0
    const columns_export_option = ''

    // on peut ajouter 'width': 200 si besoin
    function formatExportcolumn(_data: any, _row: number, _column: number, node: HTMLElement) {
        let returnData = node.textContent?.trim()
        const child = $('span[hidden]', node)
        if (child) returnData = child.innerText
        return returnData
    }

    createDataTables(table, {
        paging: false,
        info: false,
        columnDefs: temp_col,
        dom: 'Bfrtip',
        buttons: {
            buttons: [{
                extend: 'csv',
                text: "Télécharger en csv",
                className: 'fr-btn fr-mb-1w supprimer_class',
                exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }, {
                extend: 'excelHtml5',
                text: "Télécharger en excel",
                className: 'fr-btn fr-mb-1w supprimer_class',
                exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }, {
                extend: 'pdfHtml5',
                text: "Télécharger en pdf",
                className: 'fr-btn fr-mb-1w supprimer_class',
                orientation: 'landscape',
                pageSize: 'A3',
                exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }, {
                extend: 'print', text: "Imprimer", className: 'fr-btn fr-mb-1w  supprimer_class', exportOptions: {
                    columns: columns_export_option, format: {body: formatExportcolumn},
                }
            }],
        }, colReorder: true, fixedHeader: false, // stateSave: true,
        order: [[order_by, "asc"]], initComplete: function () {
            const resetFiltres = registerFiltreApi(this.api())
            $('.btn-filter', parent)?.addEventListener('click', () => {
                const filter = $('thead.filter', parent)
                const exportbtns = $('.dt-buttons', parent)

                toggle(exportbtns)
                toggle(filter)
                if (filter?.classList.contains('d-none')) {
                    resetFiltres()
                }
            });
        }
    }).then((infos) => {
        hide($('.dt-search', parent))
        hide($('.dataTables_filter', parent))
        hide($('thead.filter', parent));
        const exportbtns = $('.dt-buttons', parent)
        hide(exportbtns)
        datatables.push(infos.datatable)
    })
}